// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__hhJmC","modalFooterButton":"ModalNotes_modalFooterButton__3VEXd"};